<template>
  <section class="views">
    <headers select="5"></headers>
    <div class="posters">
      <van-image
        width="100%"
        :src="require('@/assets/image/hodgepodge/pcbanner_2026.jpg')"
      />
    </div>

    <div class="event-review">
      <div class="event-container">
        <h1 class="review-title">{{ content.title }}</h1>
        <h2 v-if="content.subtitle" class="review-title subtitle">
          {{ content.subtitle }}
        </h2>

        <div class="video-card">
          <div class="video-shell">
            <video
              class="review-video"
              :src="content.videoUrl"
              controls
              preload="metadata"
              playsinline
              webkit-playsinline="true"
              x5-playsinline="true"
              controlslist="nodownload"
            ></video>
          </div>
        </div>

        <div class="review-content">
          <template v-for="(block, index) in content.blocks">
            <p
              v-if="block.type === 'paragraph'"
              :key="`paragraph-${index}`"
              class="text-paragraph"
            >
              {{ block.text }}
            </p>

            <p
              v-else-if="block.type === 'line'"
              :key="`line-${index}`"
              class="text-line"
            >
              {{ block.text }}
            </p>

            <div
              v-else-if="block.type === 'section'"
              :key="`section-${index}`"
              :class="['section-title', block.compact ? 'compact-section' : '']"
            >
              <h2>{{ block.title }}</h2>
            </div>

            <div
              v-else-if="block.type === 'image'"
              :key="`image-${index}`"
              class="image-container"
            >
              <img class="review-image" :src="block.src" :alt="block.alt" />
              <p v-if="block.caption" class="image-caption">{{ block.caption }}</p>
            </div>

            <div
              v-else-if="block.type === 'awards'"
              :key="`awards-${index}`"
              class="award-list"
            >
              <div v-for="(group, awardIndex) in content.awardGroups" :key="awardIndex" class="award-group">
                <div class="award-group-title">{{ group.group }}</div>
                <p v-for="(award, groupIndex) in group.awards" :key="groupIndex" class="award-line">
                  {{ award }}
                </p>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from '@/components/header/pc_header';
import review2026Content from '../content';

export default {
  name: 'eventReview2026Pc',
  components: {
    headers,
  },
  data() {
    return {
      content: review2026Content,
    };
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #fff;
}

.posters {
  width: 100%;
  display: flex;
  position: relative;

  img {
    width: 100%;
  }
}

.event-review {
  width: 100%;
  padding: 30px 0;

  .event-container {
    max-width: 1024px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }

  .review-title {
    font-size: 28px;
    color: #d34a00;
    text-align: center;
    margin-bottom: 30px;
    font-weight: bold;
    line-height: 1.5;
  }

  .subtitle {
    margin-top: -10px;
  }

  .video-card {
    width: min(90%, 860px);
    margin: 0 auto 32px;
    padding: 14px;
    border-radius: 22px;
    background: linear-gradient(
      180deg,
      rgba(255, 236, 221, 0.92) 0%,
      rgba(255, 248, 242, 0.98) 100%
    );
    box-shadow: 0 14px 36px rgba(211, 74, 0, 0.14);
    border: 1px solid rgba(211, 74, 0, 0.12);
  }

  .video-shell {
    border-radius: 16px;
    overflow: hidden;
    background: #120d0a;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
  }

  .review-video {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    background: #120d0a;
  }

  .section-title {
    margin: 30px auto;
    width: 70%;
    max-width: 600px;
    padding: 20px;
    border: 2px solid #d34a00;
    border-radius: 10px;
    background: linear-gradient(to right, rgba(255, 120, 47, 0.1), rgba(255, 120, 47, 0.05));
    position: relative;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      border-style: solid;
      border-color: #d34a00;
    }

    h2 {
      margin: 0;
      color: #d34a00;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 2px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
    }

    &::before {
      top: -5px;
      left: -5px;
      border-width: 3px 0 0 3px;
      border-radius: 5px 0 0 0;
    }

    &::after {
      bottom: -5px;
      right: -5px;
      border-width: 0 3px 3px 0;
      border-radius: 0 0 5px 0;
    }
  }

  .compact-section {
    width: 48%;
    max-width: 320px;
    padding: 14px 18px;

    h2 {
      font-size: 20px;
      letter-spacing: 1px;
    }
  }

  .review-content {
    .text-paragraph {
      font-size: 16px;
      line-height: 1.8;
      color: #333;
      margin-bottom: 20px;
      text-indent: 2em;
      text-align: left;
    }

    .text-line {
      font-size: 16px;
      line-height: 1.8;
      color: #333;
      margin-bottom: 10px;
      text-align: left;
    }
  }

  .image-container {
    margin: 30px 0;
    text-align: center;

    .review-image {
      max-width: 90%;
      border-radius: 8px;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .image-caption {
      font-size: 14px;
      color: #666;
      margin-top: 10px;
      font-style: italic;
    }
  }

  .award-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    margin-top: 24px;
  }

  .award-group {
    padding: 20px;
    border-radius: 12px;
    background: linear-gradient(180deg, rgba(255, 120, 47, 0.08), rgba(255, 120, 47, 0.02));
    border: 1px solid rgba(211, 74, 0, 0.12);
    box-shadow: 0 6px 18px rgba(211, 74, 0, 0.08);
  }

  .award-group-title {
    font-size: 18px;
    font-weight: 700;
    color: #d34a00;
    margin-bottom: 12px;
  }

  .award-line {
    margin: 0 0 8px;
    font-size: 15px;
    line-height: 1.8;
    color: #333;
  }
}
</style>
